import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6a82d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "techolged" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "swiper-item" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1))
const _hoisted_8 = { style: {"display":"none"} }

import { onMounted, reactive, ref, toRefs } from 'vue'
import { searchInstance, getPickImage } from "@/api/order";
import { message } from "ant-design-vue";
import { useRoute } from "vue-router";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.less"
import SwiperCore, { EffectCoverflow } from 'swiper/core';
import { Navigation } from 'swiper'
import { getDentalCAD } from '@/api/dentalCAD';
import {formatDateTime} from "../../../components/ts/components";

export default /*#__PURE__*/_defineComponent({
  __name: 'trackOrderView',
  props: {
    id: String
},
  setup(__props) {

const props = __props;

SwiperCore.use([Navigation, EffectCoverflow]);
// 在modules加入要使用的模块
const modules = [Navigation]

let coverflowEffect = {
    rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
    stretch: 50, //每个slide之间的拉伸值，越大slide靠得越紧。
    depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。
    modifier: 4, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
    slideShadows: false //开启slide阴影。默认 true。
};
const route = useRoute();




const data = reactive<{
    currentStepArr: any[],
    monitorData: any[],
    activeIndex: number,
    activeImg: any[],
    visible: boolean
}>({
    currentStepArr: [
    ],
    monitorData: [],
    activeIndex: 0,
    activeImg: [],
    visible: false
})

const {
    monitorData,
    visible
} = toRefs(data);

onMounted(() => {
    console.log(route.query, props.id);
    let options: any = {
        "page": {
            "currPage": 1,
            "pageSize": 1000
        },
        // "rptOralTrackId": route.query.oralTrackOrderId,
        // "rptOralTrackId": 1656945463231823874,
        // "type":8,
        // "relatedId":route.query.patientId,
        "completed": true,
        "timeDesc":false
    }
    if (route.query.oralTrackOrderId) {
        options["rptOralTrackId"] = route.query.oralTrackOrderId
        options["statusList"] = [3]
    } else {
        options["relatedId"] = props.id
        options["type"] = 8
        options["statusList"] = [3, 9]
    }
    searchInstance(options).then((res: { data: any[]; }) => {
        if (res) {
            monitorData.value = res.data
            data.currentStepArr = res.data.length > 1 ? [res.data[0], res.data[1]] : [res.data[0], res.data[0]];
            data.currentStepArr.forEach((element, index) => {
                pickImage(element.id, index)
            });
        }
    })
})

let useSwiper: any = ref({}); // swiper实例

const onSwiper = (index: string | number, swiper: any) => {
    useSwiper.value[index] = swiper;
};
const onSlideChange = (index: number, swiper: any) => {
    if (index == 0) {
        if (useSwiper.value[1]) {
            useSwiper.value[1].slideTo(swiper.activeIndex, 500, false);
        }
    } else {
        if (useSwiper.value[0]) {
            useSwiper.value[0].slideTo(swiper.activeIndex, 500, false);
        }
    }
    data.activeIndex = swiper.realIndex
    data.activeImg[index] = data.currentStepArr[index].images[swiper.realIndex]
};
// 起点和终点的比较
const changeMonitor = (row: any, type: string) => {
    let currIndex = monitorData.value.findIndex(item => item.id == row.id);
    if (data.currentStepArr.length > 1) {
        let startIndex = monitorData.value.findIndex(item => item.id == data.currentStepArr[0].id);
        let endIndex = monitorData.value.findIndex(item => item.id == data.currentStepArr[1].id);
        console.log(`currIndex:${currIndex},startIndex:${startIndex},endIndex:${endIndex}`);
        if (type === "start") {
            if (currIndex >= endIndex) {
                message.warning("起点必须早于终点！");
            } else {
                data.currentStepArr = [row, data.currentStepArr[1]];
                pickImage(row.id, 0)
            }
        } else {
            if (currIndex <= startIndex) {
                message.warning("终点必须晚于起点！");
            } else {
                data.currentStepArr = [data.currentStepArr[0], row];
                pickImage(row.id, 1)
            }
        }
    } else {
        message.warning("选择错误!");
    }
    document.body.click();
}

const pickImage = (id: number, index: number) => {
    data.currentStepArr[index].images = []
    getPickImage(id).then((res: any[]) => {
        res.forEach(item => {
            let list = item.files.split(',')
            list.forEach((element: string) => {
                data.currentStepArr[index].images.push(item.prefix + '/' + element + '.JPEG')
            });
        });
        data.activeImg[index] = data.currentStepArr[index].images[data.activeIndex - 1]
    })
}

// 矫治器不贴合功能
const computedClass = (row: any) => {
    let str = "";
    if (row.currentResult === "不贴合") {
        str = "red";
    }
    if (data.currentStepArr.length > 0) {
        if (row.id === data.currentStepArr[0].id) {
            str += " start";
        }
        if (
            data.currentStepArr.length > 1 &&
            row.id === data.currentStepArr[1].id
        ) {
            str += " end";
        }
    }
    return str;
}
// 控制时间线的距离
const getGoodsStr = (row: any, arr: any) => {
    let str = "";
    if (data.currentStepArr.length > 1) {
        if (data.currentStepArr[0].id === row.id) {
            str = arr[0];
        }
        if (data.currentStepArr[1] && data.currentStepArr[1].id === row.id) {
            str = arr[1];
        }
    }
    return str;
}

const onDentalCAD = (type: string) => {
    // console.log(id, type);
    let params = {
        params: {
            // oralDesignOrderId: id,
            oralTrackOrderId: monitorData.value[monitorData.value.length - 1].rptOralTrackId,
            dentalName: type
        }
    }
    getDentalCAD(params).then((res: string) => {
        window.location.href = res + '&url=' + location.origin + '/admin';
    })
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_send_outlined = _resolveComponent("send-outlined")!
  const _component_environment_outlined = _resolveComponent("environment-outlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      title: "监控时间线",
      bordered: false
    }, {
      extra: _withCtx(() => [
        (_unref(monitorData).length > 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onDentalCAD('DentalCheck')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("3DCheck")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monitorData), (list, ind) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ind,
                  class: "goods_wrap"
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_a_tooltip, { color: '#25afd1' }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatDateTime)(list.photoEndTime)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["goods_main", computedClass(list)])
                        }, _toDisplayString(list.step), 3),
                        _createVNode(_component_a_popover, {
                          placement: "bottom",
                          trigger: "click"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (changeMonitor(list, 'start')),
                                style: {"cursor":"pointer"}
                              }, [
                                _createVNode(_component_send_outlined),
                                _createTextVNode("设为起点 ")
                              ], 8, _hoisted_2),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (changeMonitor(list, 'end')),
                                style: {"cursor":"pointer"}
                              }, [
                                _createVNode(_component_environment_outlined),
                                _createTextVNode("设为终点 ")
                              ], 8, _hoisted_3)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["goods_icon", getGoodsStr(list, ['start', 'end'])])
                            }, null, 2)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.currentStepArr, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                span: 12,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "difficulty",
                      style: _normalizeStyle({
                            backgroundColor: index === 0 ? '#af67ff' : '#6061ff',
                        })
                    }, [
                      _createTextVNode(_toDisplayString(_unref(formatDateTime)(item.photoEndTime)) + " ", 1),
                      _createElementVNode("p", null, "分析结果:" + _toDisplayString(item.result), 1)
                    ], 4),
                    _createVNode(_unref(Swiper), {
                      modules: modules,
                      "initial-slide": 1,
                      navigation: {
                            nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'
                        },
                      "centered-slides": true,
                      "slides-per-view": 1,
                      effect: 'coverflow',
                      "space-between": '-50%',
                      "coverflow-effect": _unref(coverflowEffect),
                      loop: true,
                      pagination: { clickable: true },
                      onSwiper: (swiper) => onSwiper(index, swiper),
                      onSlideChange: (swiper) => onSlideChange(index, swiper)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (url) => {
                          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: url }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", { src: url }, null, 8, _hoisted_5)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _hoisted_6,
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["navigation", "coverflow-effect", "onSwiper", "onSlideChange"]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_image, {
                        src: data.activeImg[index],
                        preview: { visible: false },
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = true))
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_a_image_preview_group, {
                          preview: { visible: _unref(visible), onVisibleChange: (vis) => (visible.value = vis) }
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.activeImg, (img) => {
                              return (_openBlock(), _createBlock(_component_a_image, {
                                key: img,
                                src: img
                              }, null, 8, ["src"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["preview"])
                      ])
                    ]),
                    _createElementVNode("div", null, " 医生建议:" + _toDisplayString(item.opinion), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})